import { render, staticRenderFns } from "./FormGoals.vue?vue&type=template&id=8b779748&"
import script from "./FormGoals.vue?vue&type=script&lang=js&"
export * from "./FormGoals.vue?vue&type=script&lang=js&"
import style0 from "./FormGoals.vue?vue&type=style&index=0&id=8b779748&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports